document.addEventListener("DOMContentLoaded", () => {

  // FUNCTION TO TOGGLE CONFIRM BUTTON STATE  
  function updateConfirmButtonState(popupBox){
    const confirmBtn = popupBox.querySelector(".ws-confirm-btn");
    const hasAdded = popupBox.querySelector(".ws-popup-item.added-to-total") ? true : false;

    if(hasAdded){
      confirmBtn.classList.add("confirm-active");
    } else {
      confirmBtn.classList.remove("confirm-active");
    }
  }

  // FUNCTION TO RECALCULATE TOTAL

  function recalcTotal(popupBox){
    const totalBox = popupBox.querySelector(".ws-total-box strong");
    let finalTotal = 0;

    popupBox.querySelectorAll(".ws-popup-item.added-to-total").forEach(itemBox => {
      const priceEl  = itemBox.querySelector(".ws-item-price");
      let price      = parseFloat(priceEl.getAttribute("data-price")) || 0;
      price          = price / 100;

      const qtyInput = itemBox.querySelector("input[name='quantity']");
      const qty      = parseInt(qtyInput.value) || 0;

      finalTotal += price * qty;
    });

    if(totalBox) totalBox.innerHTML = "Dhs. " + finalTotal.toFixed(2);

    // UPDATE CONFIRM BUTTON HERE
    updateConfirmButtonState(popupBox);
  }


  // GLOBAL CLICK HANDLER

  document.addEventListener("click", function(e){
    const target = e.target;

    // OPEN POPUP

    const openBtn = target.closest(".ws-open-popup-btn");
    if(openBtn){
      e.preventDefault();
      console.log("openBtn.dataset.target:--",openBtn.dataset.target);
      const popup = document.getElementById(openBtn.dataset.target);
      if(!popup) return;

      popup.classList.add("active");
      document.body.classList.add("modal-opened");

      // RESET ITEMS

      popup.querySelectorAll(".ws-popup-item").forEach(item => {
        const addBtn = item.querySelector(".pop-up-add-button");
        const qtyBox = item.querySelector(".ws-qty-box");
        const qtyInput = item.querySelector("input[name='quantity']");
        if(addBtn) addBtn.style.display = "block";
        if(qtyBox) qtyBox.style.display = "none";
        if(qtyInput) qtyInput.value = 0;
        item.classList.remove("added-to-total");
      });

      // reset total

      const totalBox = popup.querySelector(".ws-total-box strong");
      if(totalBox) totalBox.innerHTML = "Dhs. 0.00";

      // UPDATE CONFIRM BUTTON
      updateConfirmButtonState(popup);

      return;
    }

    // CLOSE POPUP

    const popupOverlay = target.closest(".ws-popup-overlay");
    if(popupOverlay && (target.classList.contains("ws-popup-overlay") || target.classList.contains("ws-close-popup"))){
      popupOverlay.classList.remove("active");
      document.body.classList.remove("modal-opened");
      return;
    }

    // ADD / QTY BUTTONS

    setTimeout(() => {
    const itemBox = target.closest(".ws-popup-item");
    if(itemBox){
      const popupBox = itemBox.closest(".ws-popup");
      const qtyBox = itemBox.querySelector(".ws-qty-box");
      const addBtn = itemBox.querySelector(".pop-up-add-button");
      const qtyInput = itemBox.querySelector("input[name='quantity']");
      const qtyMinus = itemBox.querySelector(".qty-minus");
      const qtyPlus = itemBox.querySelector(".qty-plus");

      function toggleAddQty() {
        const qty = parseInt(qtyInput.value) || 0;
        if(qty <= 0){
          if(qtyBox) qtyBox.style.display = "none";
          if(addBtn) addBtn.style.display = "block";
          itemBox.classList.remove("added-to-total");
        } else {
          if(qtyBox) qtyBox.style.display = "block";
          if(addBtn) addBtn.style.display = "none";
          itemBox.classList.add("added-to-total");
        }
      }

      // Add button

      if(target.closest(".pop-up-add-button")){
        if(qtyBox) qtyBox.style.display = "block";
        if(!qtyInput.value || parseInt(qtyInput.value) <= 0) qtyInput.value = 1;
        toggleAddQty();
        recalcTotal(popupBox);
        return;
      }

      // Plus/Minus buttons

      if(target.closest(".qty-minus") || target.closest(".qty-plus")){
        setTimeout(() => {
          toggleAddQty();
          recalcTotal(popupBox);
        }, 10);
        return;
      }
    }
    }, 100);


    // CONFIRM BUTTON CLICK (ADD TO CART)

    const confirmBtn = target.closest(".ws-confirm-btn");
    if(confirmBtn){
      const popupBox = confirmBtn.closest(".ws-popup");
      const items = [];

      popupBox.querySelectorAll(".ws-popup-item.added-to-total").forEach(item => {
        const variantId = item.getAttribute("data-variant-id");
        const qty = parseInt(item.querySelector("input[name='quantity']").value) || 0;
        if(qty > 0) items.push({ id: variantId, quantity: qty });
      });

      if(items.length === 0){
        console.log("No items added.");
        return;
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: items })
      })
      .then(res => res.json())
      .then(data => {
        // console.log("Added to cart:", data);

        document.querySelectorAll(".ws-popup-overlay").forEach(overlay => {
          overlay.classList.remove("active");
        });

        if(typeof window.refreshCart === "function") window.refreshCart();
        document.body.classList.remove("modal-opened");

        // const cartSidebar = document.getElementById("site-cart-sidebar");
        // if(cartSidebar && typeof cartSidebar.show === "function") cartSidebar.show();

        const triggerBtn = popupBox.closest(".product-item").querySelector(".product-item__quick-buy");

        if(triggerBtn)
          {
            triggerBtn.classList.add("product-added");

              setTimeout(() => {
                triggerBtn.classList.remove("product-added");
              }, 5000);
          }
      })
      .catch(err => console.error("Error:", err));
      return;
    }

    if(target.closest("[data-js-close]")){
      document.querySelectorAll(".ws-popup-overlay").forEach(overlay => {
        overlay.classList.remove("active");
      });
      document.body.classList.remove("modal-opened");
      return;
    }
  });


  // GLOBAL INPUT LISTENER

  document.addEventListener("input", function(e){
    const qtyInput = e.target.closest("input[name='quantity']");
    if(!qtyInput) return;

    const itemBox = qtyInput.closest(".ws-popup-item");
    const popupBox = itemBox.closest(".ws-popup");

    const qtyBox = itemBox.querySelector(".ws-qty-box");
    const addBtn = itemBox.querySelector(".pop-up-add-button");
    const qty = parseInt(qtyInput.value) || 0;

    if(qty <= 0){
      if(qtyBox) qtyBox.style.display = "none";
      if(addBtn) addBtn.style.display = "block";
      itemBox.classList.remove("added-to-total");
    } else {
      if(qtyBox) qtyBox.style.display = "block";
      if(addBtn) addBtn.style.display = "none";
      itemBox.classList.add("added-to-total");
    }

    recalcTotal(popupBox);
  });

});
